import { rootApi } from "..";
import {
  ITeamMembersConveyanceAction,
  teamMemberService,
} from "../../../Api/Services/TeamMembers";
import {
  IBulkAttendanceParams,
  ITeamMembersAttendanceListParams,
  ITeamMembersAttendanceForm,
} from "../../../features/teamMembers/attendanceList/types";
import { IFetchTeamMembersParams } from "../../../features/teamMembers/conveyanceList/types";
import { IDailyDairyReportParams } from "../../../features/teamMembers/dailyDairyReport/types";
import {
  IApprovedLeaveFormData,
  IBulkLeaveParams,
  ITeamMembersLeaveListParams,
} from "../../../features/teamMembers/leaveList/types";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

const teamMembersEndpoints = [
  {
    name: "teamMembersList",
    type: "query",
    serviceFn: (employeeId?: number) =>
      teamMemberService.getTeamMembers(employeeId),
    tagType: "TeamMembersInfo",
  },
  {
    name: "teamMembersAttendanceList",
    type: "query",
    serviceFn: ({
      user,
      activeYear,
      type,
      status,
    }: ITeamMembersAttendanceListParams) =>
      teamMemberService.fetchTeamMemberAttendance(
        user,
        activeYear,
        type,
        status
      ),
    tagType: "TeamMembersAttendance",
  },
  {
    name: "teamMembersLeaveList",
    type: "query",
    serviceFn: ({ user, activeYear, type, status }: ITeamMembersLeaveListParams) =>
      teamMemberService.fetchTeamMembersLeave(user, activeYear, type, status),
    tagType: "TeamMembersLeaves",
  },
  {
    name: "teamMembersConveyanceList",
    type: "query",
    serviceFn: ({
      employeeId,
      startDate,
      endDate,
      selectEmployeeId,
      page,
      size,
      type,
      status,
    }: IFetchTeamMembersParams) =>
      teamMemberService.fetchTeamMembersConveyance({
        employeeId,
        startDate,
        endDate,
        selectEmployeeId,
        page,
        size,
        type,
        status
      }),
    tagType: "TeamMembersConveyance",
  },
  {
    name: "teamMembersDailyDairyReport",
    type: "mutation",
    serviceFn: (params: IDailyDairyReportParams) =>
      teamMemberService.dailyDairyReport(params),
  },
  {
    name: "teamMemberApproveAttendance",
    type: "mutation",
    serviceFn: (attendanceCorrectionData: ITeamMembersAttendanceForm) =>
      teamMemberService.updateAttendanceStatus(attendanceCorrectionData),
    tagType: "TeamMembersAttendance",
  },
  {
    name: "teamMemberApproveLeave",
    type: "mutation",
    serviceFn: (leaveApproveData: IApprovedLeaveFormData) =>
      teamMemberService.approveLeave(leaveApproveData),
    tagType: "TeamMembersLeaves",
  },
  {
    name: "teamMembersBulkApproveAttendance",
    type: "mutation",
    serviceFn: ({ action, attendance_request_ids }: IBulkAttendanceParams) =>
      teamMemberService.bulkApprovedAttendanceRequest({
        attendance_request_ids,
        action,
      }),
    tagType: "TeamMembersAttendance",
  },
  {
    name: "teamMembersBulkApproveLeave",
    type: "mutation",
    serviceFn: ({ action, comment, leave_id }: IBulkLeaveParams) =>
      teamMemberService.bulkApproveLeaveRequest({ action, comment, leave_id }),
    tagType: "TeamMembersLeaves",
  },
  {
    name: "teamMembersConveyanceAction",
    type: "mutation",
    serviceFn: (params: ITeamMembersConveyanceAction) =>
      teamMemberService.teamMembersConveyanceAction(params),
    tagType: "TeamMembersConveyance",
  },
] as const;

export const teamMembersEndpointsApi = rootApi.injectEndpoints({
  endpoints: (builder) => makeEndpoints(builder, teamMembersEndpoints),
});

export const {
  useTeamMembersListQuery,
  useTeamMembersLeaveListQuery,
  useTeamMembersConveyanceListQuery,
  useLazyTeamMembersConveyanceListQuery,
  useTeamMembersAttendanceListQuery,
  useTeamMemberApproveLeaveMutation,
  useTeamMembersConveyanceActionMutation,
  useTeamMemberApproveAttendanceMutation,
  useTeamMembersBulkApproveLeaveMutation,
  useTeamMembersDailyDairyReportMutation,
  useTeamMembersBulkApproveAttendanceMutation,
} = teamMembersEndpointsApi;

